import React, { useState } from 'react'
import { TbBulb } from 'react-icons/tb'
import MenuButton from '@ui/MenuButton'
import CannyFeedback from '@components/CannyFeedback/CannyFeedback'

const GotIdeaButton = () => {
  const [feedbackOpen, setFeedbackOpen] = useState(false)

  return null

  return (
    <>
      {/* <CannyFeedback onClose={() => setFeedbackOpen(false)} open={feedbackOpen} /> */}
      <MenuButton
        icon={TbBulb}
        onClick={() => {
          window.open('https://enhanci.featurebase.app/', '_blank')
        }}
      >
        Got an idea?
      </MenuButton>
    </>
  )
}

export default GotIdeaButton
